import { useEffect, useState } from "react";
import "@/App.css";
import axios from "axios";
import { Toaster } from "@/components/ui/sonner";

import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Stats from "@/components/site/Stats";
import About from "@/components/site/About";
import Founder from "@/components/site/Founder";
import Programs from "@/components/site/Programs";
import ImpactStory from "@/components/site/ImpactStory";
import Events from "@/components/site/Events";
import Volunteer from "@/components/site/Volunteer";
import Donate from "@/components/site/Donate";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function App() {
  const [stats, setStats] = useState(null);
  const [programs, setPrograms] = useState([]);
  const [events, setEvents] = useState([]);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const [s, p, e] = await Promise.all([
          axios.get(`${API}/stats`),
          axios.get(`${API}/programs`),
          axios.get(`${API}/events`),
        ]);
        if (!mounted) return;
        setStats(s.data);
        setPrograms(p.data);
        setEvents(e.data);
      } catch (err) {
        console.error("Failed to load site data", err);
      }
    })();
    return () => {
      mounted = false;
    };
  }, []);

  return (
    <div className="App" data-testid="app-root">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Stats stats={stats} />
        <About />
        <Founder />
        <Programs programs={programs} />
        <ImpactStory />
        <Events events={events} />
        <Volunteer api={API} programs={programs} />
        <Donate api={API} programs={programs} />
        <Contact api={API} />
      </main>
      <Footer api={API} />
      <Toaster
        position="bottom-right"
        toastOptions={{
          classNames: {
            toast: "border border-line bg-cream text-ink font-sans",
            title: "font-serif text-lg",
            description: "text-graphite",
          },
        }}
      />
    </div>
  );
}

export default App;
